import { useState } from "react";

function CertificateCard({ cert, onSelect }) {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = Boolean(cert.image) && !imageFailed;

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect(cert);
    }
  };

  return (
    <div
      className="certificate-card reveal"
      onClick={() => onSelect(cert)}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="certificate-avatar">
        {showImage ? (
          <img
            alt={`${cert.title} certificate`}
            className="certificate-thumb"
            onError={() => setImageFailed(true)}
            src={cert.image}
          />
        ) : (
          <span className="certificate-icon">CERT</span>
        )}
      </div>
      <div className="certificate-body">
        <div className="certificate-title">{cert.title}</div>
        <div className="certificate-issuer">{cert.issuer}</div>
        <div className="certificate-date">{cert.date}</div>
      </div>
      <span className="certificate-expand" aria-hidden="true">
        View
      </span>
    </div>
  );
}

export default CertificateCard;
